import { useInfiniteQuery } from '@tanstack/react-query';

import { type SortingDir } from '@app/client';
import { callGetAdminCompetitions } from '@app/client/resources/admin/fantasy/competitions';
import { COMPETITIONS_CACHE } from '@app/client/resources/competitions';

import { getNextPageParam, getPagesPagingParams } from '../../../deprecated';

export interface SortParams {
    sortDirectionQuery?: SortingDir;
    sortField?: string;
}

export function useGetAdminCompetitions({
    sortDirectionQuery = 'Desc',
    sortField = 'submission_starts_at',
}: SortParams) {
    const cache = [COMPETITIONS_CACHE, sortDirectionQuery, sortField];

    const { data, ...rest } = useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) => {
            const pageQueries = { page: pageParam, limit: 20 };
            const sortQueries = { dir: sortDirectionQuery, sort: sortField as string };
            const query = { ...pageQueries, ...sortQueries };
            return callGetAdminCompetitions({
                query,
                settings: { signal },
            });
        },
        {
            retry: false,
            keepPreviousData: true,
            getNextPageParam,
        },
    );
    const pagingParams = getPagesPagingParams(data?.pages);
    const games = data?.pages[pagingParams?.page || 0]?.data;

    return {
        data,
        games,
        pagingParams,
        ...rest,
    };
}
